const GOOGLE_CALENDAR_API_KEY = 'AIzaSyBAVtelIrW2nNaefyxUPtSGHSWKmhcomY0';
const JAPANESE_HOLIDAY_CALENDAR_ID = 'japanese__ja@holiday.calendar.google.com';

export const JAPANESE_HOLIDAY_SOURCE_ID = 'japanese-holidays';

export async function loadJapaneseHolidayEvents(start: Date, end: Date): Promise<any[]> {
  const query = new URLSearchParams({
    key: GOOGLE_CALENDAR_API_KEY,
    timeMin: start.toISOString(),
    timeMax: end.toISOString(),
    singleEvents: 'true',
    orderBy: 'startTime',
    maxResults: '2500',
  });
  const calendarId = encodeURIComponent(JAPANESE_HOLIDAY_CALENDAR_ID);
  const response = await fetch(`https://www.googleapis.com/calendar/v3/calendars/${calendarId}/events?${query}`);
  if (!response.ok) {
    throw new Error(`Google Calendar API request failed: ${response.status}`);
  }

  const data = await response.json();
  return (data?.items ?? [])
    .flatMap((item: any) => {
      const start = item.start?.date ?? item.start?.dateTime;
      const end = item.end?.date ?? item.end?.dateTime;
      if (!start || !end) return [];

      const holiday = {
        title: item.summary ?? '',
        start,
        end,
        allDay: true,
        extendedProps: { type: 'holiday' },
      };

      // FullCalendar v6のbackgroundイベントは標準ではタイトルを描画しないため、
      // eventContent側で名称DOMを追加する。イベント自体は旧画面と同じ1件にする。
      return [
        {
          ...holiday,
          id: `japanese-holiday-${item.id}-background`,
          display: 'background',
          backgroundColor: '#ffeaea',
          borderColor: '#ffeaea',
        },
      ];
    });
}
